import store from 'store'
import { COOKIE_KEYS, getCookie, LOCALSTORAGE_KEYS } from '@features/General'
interface IUser {
    cognitoUserIds: string[]
    createdAt: string
    email: string
    eventInfos: any[]
    location: any
    company?: string
    role?: any
    status: string
    updatedAt: string
    __v: number
    _id: string
    firstname?: string
    lastname?: string
    avatar?: string
}

function useUser() {
    const user: IUser = store.get(LOCALSTORAGE_KEYS.USERINFO)
    const eventId = getCookie(COOKIE_KEYS.ALA_EVENT)
    const companyId = user?.eventInfos.find(x => x.eventId === eventId)?.companyId || undefined
    const appDirection = getCookie(COOKIE_KEYS.ALA_DIRECTION)
    return {
        user,
        eventId,
        companyId,
        appDirection
    }
}

export default useUser
